module.exports = __webpack_public_path__ + "img/purpleClock.fd531667.png";